import api from "./api";
import { generateErrorMessage } from "../utils/message";


/*Business*/

export const registerBusiness = async (userData) => {
  try {
    const response = await api.post("/business/", userData);
    return response.data;
  } catch (error) {
    const fallback = generateErrorMessage("register", "busines");
    const msg = error.response?.data?.message || fallback;
    throw new Error(msg);
  }
};

export const fetchBusinessFromAPI = async (page = 1, perPage = 10, search = "") => {
  try {
    const response = await api.get("/business", {
      params: { page, per_page: perPage, search },
    });

    return response.data.data;
  } catch (error) {
    const fallback = generateErrorMessage("get data", "business");
    const msg = error.response?.data?.message || fallback;
    throw new Error(msg);
  }
};

export const deleteBusinessFromAPI = async (businesId) => {
  try {
    const response = await api.delete(`/auth/business/${businesId}`, {
      params: { busines_id: businesId },
    });
    return response.data;
  } catch (error) {
    const fallback = generateErrorMessage("delete data", "business");
    const msg = error.response?.data?.message || fallback;
    throw new Error(msg);
  }
};


export const fetchBusinessById = async (businesId) => {
  try {
    const response = await api.get(`/auth/business/${businesId}`);
    return response.data;
  } catch (error) {
    const fallback = generateErrorMessage("get data busines", "busines");
    const msg = error.response?.data?.message || fallback;
    throw new Error(msg);
  }
};

export const updateBusiness = async (id, businesData) => {
  try {
    const response = await api.put(`/auth/business/${id}`, businesData);
    return response.data;
  } catch (error) {
    const fallback = generateErrorMessage("update", "busines");
    const msg = error.response?.data?.message || fallback;
    throw new Error(msg);
  }
};

